<template>
  <v-dialog v-model="dialog" width="1100px" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable>
    <v-card>
      <v-card-title class="primary white--text"
        ><v-toolbar-title>Xem chi tiết</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card-text :class="{ 'doc-type': !isPdf }">
        <div v-if="isPdf">
          <pdf v-for="i in numPages" :key="i" :src="file && file.url" :page="i" style="width: 100%;"></pdf>
        </div>
        <VueDocPreview type="office" :value="file && file.url" v-else />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-4">
        <v-btn class="px-6" outlined light depressed @click="openLink">Tải xuống</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" width="100px" class="elevation-0" @click="cancel">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import pdf from 'vue-pdf'
import VueDocPreview from 'vue-doc-preview'

export default {
  components: {
    pdf,
    VueDocPreview
  },
  props: {
    state: {
      type: Boolean,
      default: () => false
    },
    file: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialog: false,
      numPages: 0,
      isPdf: false
    }
  },

  methods: {
    cancel() {
      this.dialog = false
    },
    openLink() {
      if (this.file.url) window.open(this.file.url, '_blank')
    }
  },
  watch: {
    async state(state) {
      this.dialog = true
      if (this.file && this.file.name) {
        this.$loading.active = true
        this.isPdf = false

        if (this.file.name.endsWith('.pdf')) {
          this.isPdf = true
          const f = await pdf.createLoadingTask(this.file.url).promise
          this.numPages = f.numPages
        }

        this.$loading.active = false
      }
    }
  }
}
</script>
<style scoped>
.doc-type {
  overflow: hidden !important;
}
</style>
